var T = function (k, f) { var d = typeof window !== 'undefined' && window.VP_I18N; return d && typeof d[k] === 'string' ? d[k] : f; }; // vp-i18n T()
/* Pre-launch popup（2026-09-19；09-24 加左侧领券小标签，见 showTab/hideTab）
   规则：
   · 首页：世界门（gateway）选好世界、app.js 派发 vp:entryready 之后再等 N 秒弹；
     门还没关绝不弹。其它页：load 之后等 N 秒。
   · 每个访客只弹一次；点关闭 / 「Just browsing」= 冷却 N 天；订阅成功 = 永久不弹。
   · 订阅用 Shopify 原生 customer 表单（contact[email] + contact[tags]），**必须原生提交**：
     Shopify 给 customer 表单开了验证码（Missing CAPTCHA token → 400），它注入的
     storefront 脚本只拦截真实的 submit 事件来补 token；fetch 或 form.submit() 都绕过它
     （2026-09-19 线上实测 fetch 直接 400）。所以这里只做校验 + 打标记，然后放行浏览器提交。
     Shopify 处理完会带 ?customer_posted=true#prelaunchSubscribe 跳回本页，
     靠 sessionStorage 标记认出是弹窗提交的，再弹成功态；被验证码挑战时会先去 /challenge 再回来，同样走这条路。
   · 页脚订阅框成功回来（带 customer_posted=true 但不是弹窗提交的）→ 记为已订阅，不再弹。 */
(function () {
  "use strict";
  var root = document.documentElement;
  var box = document.querySelector("[data-prelaunch]");
  if (!box) return;
  var KEY = "vp-prelaunch-v1";
  var SUBMIT_KEY = "vp-prelaunch-submitting";
  // 2026-09-25：测试开关。网址带 ?reset-offer=1 就清掉本机的订阅 / 关闭记录，像新访客一样重新走一遍弹窗和左侧领券标签
  //（用户手机上测过订阅，被记成已订阅，按规则不再显示标签；微信内置浏览器没法清缓存，用这个）
  try { if (/[?&]reset-offer=1(?:&|$)/.test(window.location.search)) { localStorage.removeItem(KEY); localStorage.removeItem("vp-offer-tab-v1"); sessionStorage.removeItem(SUBMIT_KEY); } } catch (_) {}
  var card = box.querySelector(".vp-prelaunch__card");
  var copy = box.querySelector(".vp-prelaunch__copy");
  var done = box.querySelector("[data-prelaunch-done]");
  var form = box.querySelector("[data-prelaunch-form]");
  var email = box.querySelector("#vpPrelaunchEmail");
  var error = box.querySelector("[data-prelaunch-error]");
  var countdown = box.querySelector("[data-prelaunch-countdown]");
  var delay = (parseFloat(box.getAttribute("data-prelaunch-delay")) || 0) * 1000;
  var snoozeDays = parseFloat(box.getAttribute("data-prelaunch-snooze")) || 7;
  // 2026-10-11 用户：「欧洲的弹窗不再自动弹了，关掉，因为要弹 Cookie 横幅」。
  // · 欧盟 / 瑞士市场：Liquid 按市场写 data-prelaunch-auto="0" → 不自动弹（见 arm()）。
  // · 其它市场（如英国走全球站）：只要 Shopify 判定这位访客要看 Cookie 横幅（需同意地区），这次不弹，并在本机记 vp-consent-region，以后也不自动弹。
  // · 左下角「10% off」小标签照常显示，点开照常能领券；美国等不弹横幅的地区照旧 8 秒弹。
  var AUTO_OFF = box.getAttribute("data-prelaunch-auto") === "0";
  // 2026-10-14 用户：「广告来的访客不弹礼物全屏」→ 带广告参数进站（gclid / gbraid / wbraid / gad_source / fbclid / msclkid / ttclid，
  // 或 utm_medium 是 cpc / ppc / paid… / product_sync / display / shopping）的访客，这次和之后 7 天都不自动弹；左下角小标签照常，点开照常能领券。
  var AD_KEY = "vp-ad-visit";
  var AD_RE = /[?&](?:gclid|gbraid|wbraid|gad_source|gad_campaignid|fbclid|msclkid|ttclid)=|[?&]utm_medium=(?:cpc|ppc|paid[^&]*|product_sync|display|shopping)(?:&|$)/i;
  var adVisit = false;
  try {
    if (AD_RE.test(window.location.search)) { localStorage.setItem(AD_KEY, String(Date.now())); adVisit = true; }
    else { var adAt = +localStorage.getItem(AD_KEY) || 0; adVisit = adAt > 0 && Date.now() - adAt < 7 * 864e5; }
  } catch (_) { adVisit = AD_RE.test(window.location.search); }
  var REGION_KEY = "vp-consent-region";
  function consentRegion() { try { return localStorage.getItem(REGION_KEY) === "1"; } catch (_) { return false; } }
  function markRegion() { try { localStorage.setItem(REGION_KEY, "1"); } catch (_) {} }
  var coarse = false;
  try { coarse = window.matchMedia("(pointer: coarse)").matches || window.innerWidth <= 640; } catch (_) {}
  var isOpen = false;
  var lastFocus = null;
  // 2026-09-27：Ahrefs 自定义事件（弹窗曝光 / 关闭 / 提交 / 订阅成功）。analytics.js 是 async 的，没到就每 0.5 秒再试，最多 10 秒
  function track(name, props) {
    var tries = 0;
    (function go() {
      var a = window.AhrefsAnalytics;
      if (a && typeof a.sendEvent === "function") { try { a.sendEvent(name, props ? { props: props } : undefined); } catch (_) {} return; }
      if (++tries < 20) window.setTimeout(go, 500);
    })();
  }
  var openedVia = "";
  // 2026-09-28：「Popup submit」「Popup subscribed」上线后一次都没记上——原生表单提交会整页跳转，
  // track() 走 AhrefsAnalytics.sendEvent（异步 XHR），请求还没发完页面就走了。这两个事件改用 navigator.sendBeacon
  // 直发 Ahrefs 事件接口（页面卸载也会送达）。负载照 analytics.js 源码：{n,u,l,k,r,p,sw,sh,sr,t}，text/plain；
  // key 读页面上 analytics.js 那个 script 标签的 data-key。和 analytics.js 一样跳过 webdriver / 本机访问
  // （测试时设 window.__web_analytics = true 才发）。浏览器没有 sendBeacon 或拒收时退回 track()。
  function beacon(name, props) {
    var sent = false;
    try {
      if ((window._phantom || window.__nightmare || navigator.webdriver || window.Cypress) && !window.__web_analytics) return;
      if (/^localhost$|^127(\.[0-9]+){0,2}\.[0-9]+$|^\[::1?\]$/.test(window.location.hostname) || window.location.protocol === "file:") return;
      var s = document.querySelector('script[src*="analytics.ahrefs.com/analytics.js"]:not([type="text/plain"])');
      var key = s && s.getAttribute("data-key");
      if (key && navigator.sendBeacon && window.Blob) {
        var d = { n: name, u: window.location.href };
        var langs = navigator.languages || navigator.language;
        if (langs != null) d.l = langs;
        d.k = key;
        d.r = document.referrer || null;
        if (props) d.p = JSON.stringify(props);
        d.sw = window.screen.width;
        d.sh = window.screen.height;
        d.sr = window.devicePixelRatio;
        d.t = document.title;
        var api = s.getAttribute("data-api") || new URL(s.src).origin + "/api/event";
        sent = navigator.sendBeacon(api, new Blob([JSON.stringify(d)], { type: "text/plain" }));
      }
    } catch (_) {}
    if (!sent) track(name, props);
  }
  var submitSent = false;
  // 订阅成功回跳只记一次：同一会话里刷新 / 前进后退回到这个网址不重复发
  var SUBSCRIBED_SENT_KEY = "vp-popup-subscribed-sent";
  function subscribedOnce() {
    try { if (sessionStorage.getItem(SUBSCRIBED_SENT_KEY)) return; sessionStorage.setItem(SUBSCRIBED_SENT_KEY, "1"); } catch (_) {}
    beacon("Popup subscribed");
  }

  // ---- 左侧领券小标签（2026-09-24）：弹窗关掉后留在页面左边，点它重新打开弹窗；× 收起 N 天；订阅过就不再出现 ----
  var TAB_KEY = "vp-offer-tab-v1";
  var tab = document.querySelector("[data-offer-tab]");
  var tabSnooze = tab ? (parseFloat(tab.getAttribute("data-offer-tab-snooze")) || 3) : 3;
  function tabSnoozed() {
    try { var t = JSON.parse(localStorage.getItem(TAB_KEY) || "null"); return !!(t && Date.now() - (t.ts || 0) < tabSnooze * 864e5); } catch (_) { return false; }
  }
  function showTab() {
    if (!tab || tabSnoozed()) return;
    var s = read();
    if (s && s.state === "subscribed") return;
    tab.hidden = false;
    placeTab();   // 2026-09-28：先看落点下面有没有字 / 控件 / 购买区，有就先收着（见 placeTab）
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { tab.classList.add("is-in"); }); });
  }
  function hideTab(persist) {
    if (!tab) return;
    tab.classList.remove("is-in");
    if (persist) { try { localStorage.setItem(TAB_KEY, JSON.stringify({ ts: Date.now() })); } catch (_) {} }
    window.setTimeout(function () { if (!tab.classList.contains("is-in")) tab.hidden = true; }, 400);
  }
  if (tab) {
    var tabOpen = tab.querySelector("[data-offer-tab-open]");
    var tabClose = tab.querySelector("[data-offer-tab-close]");
    if (tabOpen) tabOpen.addEventListener("click", function () {
      if (copy) copy.hidden = false;
      if (done) done.hidden = true;
      open("tab");
    });
    if (tabClose) tabClose.addEventListener("click", function () { hideTab(true); });
  }
  // 2026-09-28：小标签不许压住内容。原来手机上竖条固定在左侧 y596–712，压住合集页左列卡片的标题 / 价格和商品页的 Size 下拉。
  // 现在：手机（≤640px）改成左下角横向小胶囊，桌面仍是左侧竖条（1440 宽时在页边空白里）；两者共用一条规则——
  //  · 落点下面有可见文字、按钮 / 输入框 / 下拉，或叠到商品购买表单 / 加购 / 结账按钮上，就收起（.is-tucked，淡出）；
  //  · 滚动中只收不放，停下 0.35 秒后落点空了再放出来；平时每 1.5 秒复查一次（轮播 / 懒加载会让下面的内容变）；
  //  · 手机上 Google 评价徽章（google-reviews-badge 片段，LEFT_BOTTOM）真的显示出来时把胶囊抬到徽章上方（Google 要求徽章不被遮挡）；
  //  · 键盘焦点在小标签上时不收。右下角是 app.js 的「回到顶部」，所以放左边。
  // 外层 .vp-offer-tab 不做进出动画、不接点击，只有里面两个按钮淡入淡出，所以量外层就是它的落点。
  var TAB_GUARD = 'form[action*="/cart/add"], [name="add"], [name="checkout"], a[href*="/checkout"], #google-merchantwidget-iframe-wrapper';
  var TAB_CTRL = 'input:not([type="hidden"]), select, textarea, button, [role="button"]';
  var tabPill = window.matchMedia ? window.matchMedia("(max-width: 640px)") : null;
  var tabQueued = false, tabScrolling = false, tabIdle = 0;
  function tabBoxHit(r, box) { return r.width > 0 && r.height > 0 && r.left < box.right && r.right > box.left && r.top < box.bottom && r.bottom > box.top; }
  function tabBlocked(box) {
    var list, i;
    try { list = document.querySelectorAll(TAB_GUARD); } catch (_) { list = []; }
    for (i = 0; i < list.length; i++) if (tabBoxHit(list[i].getBoundingClientRect(), box)) return true;
    if (!document.createTreeWalker || !document.createRange || !window.NodeFilter) return false;
    // 从 body 往下走，只钻进跟落点相交的元素（不相交的整棵子树剪掉），找落点下面的文字和控件
    var hit = false, range = document.createRange();
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      if (n.nodeType === 3) return /\S/.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      if (n === tab) return NodeFilter.FILTER_REJECT;
      var r = n.getBoundingClientRect();
      if (!r.width && !r.height) return window.getComputedStyle(n).display === "contents" ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_REJECT;
      if (r.width <= 2 || r.height <= 2 || !tabBoxHit(r, box)) return NodeFilter.FILTER_REJECT;   // 读屏专用的 1px 文字、不相交的整棵剪掉
      var cs = window.getComputedStyle(n);
      if (cs.visibility === "hidden" || +cs.opacity < 0.05) return NodeFilter.FILTER_REJECT;
      if (n.matches && n.matches(TAB_CTRL)) { hit = true; return NodeFilter.FILTER_ACCEPT; }
      return NodeFilter.FILTER_SKIP;
    } });
    var n;
    while (!hit && (n = walker.nextNode())) {
      if (n.nodeType !== 3) continue;
      range.selectNodeContents(n);
      var rs = range.getClientRects();
      for (i = 0; i < rs.length; i++) if (tabBoxHit(rs[i], box)) { hit = true; break; }
    }
    return hit;
  }
  function placeTab() {
    tabQueued = false;
    if (!tab || tab.hidden) return;
    var lift = "";
    if (tabPill && tabPill.matches) {
      var g = document.getElementById("google-merchantwidget-iframe-wrapper");
      var gr = g && g.getBoundingClientRect();
      if (gr && gr.width > 1 && gr.height > 1 && gr.left < window.innerWidth / 2) lift = Math.round(window.innerHeight - gr.top + 12) + "px";
    }
    if (tab.style.bottom !== lift) tab.style.bottom = lift;
    var tucked = tab.classList.contains("is-tucked");
    if (tabScrolling && tucked) return;   // 滚动中只收不放
    var b = tab.getBoundingClientRect();
    var blocked = !tab.contains(document.activeElement) && tabBlocked({ left: b.left - 4, right: b.right + 10, top: b.top - 10, bottom: b.bottom + 4 });
    if (blocked !== tucked) tab.classList.toggle("is-tucked", blocked);
  }
  function queueTab() { if (!tabQueued) { tabQueued = true; window.requestAnimationFrame(placeTab); } }
  if (tab) {
    window.addEventListener("scroll", function () {
      tabScrolling = true;
      window.clearTimeout(tabIdle);
      tabIdle = window.setTimeout(function () { tabScrolling = false; queueTab(); }, 350);
      queueTab();
    }, { passive: true });
    window.addEventListener("resize", queueTab);
    window.addEventListener("pageshow", queueTab);
    tab.addEventListener("focusin", queueTab);
    tab.addEventListener("focusout", queueTab);
    window.setInterval(function () { if (!tab.hidden && !document.hidden) queueTab(); }, 1500);
    // Google 徽章的外层 div 是 merchantwidget.js 晚些时候插进 body 的：插进来以后盯它（和里面 iframe）的 style 变化
    if (window.MutationObserver) {
      var watchBadge = function () {
        var g = document.getElementById("google-merchantwidget-iframe-wrapper");
        if (!g) return false;
        new MutationObserver(queueTab).observe(g, { attributes: true, subtree: true, attributeFilter: ["style"] });
        queueTab();
        return true;
      };
      if (!watchBadge() && document.body) {
        var badgeMo = new MutationObserver(function () { if (watchBadge()) badgeMo.disconnect(); });
        badgeMo.observe(document.body, { childList: true });
        window.setTimeout(function () { badgeMo.disconnect(); }, 60000);
      }
    }
  }

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch (_) { return null; } }
  function write(state) { try { localStorage.setItem(KEY, JSON.stringify({ state: state, ts: Date.now() })); } catch (_) {} }

  // 倒计时：按本地日历日算（19 号看 25 号 = 6 天），1–30 天内才显示
  (function renderCountdown() {
    if (!countdown) return;
    var m = (box.getAttribute("data-prelaunch-date") || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return;
    var now = new Date();
    var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    var target = Date.UTC(+m[1], +m[2] - 1, +m[3]);
    var days = Math.round((target - today) / 864e5);
    if (days >= 1 && days <= 30) {
      var tail = document.createElement("span");
      tail.className = "vp-prelaunch__days";
      tail.textContent = days + (days === 1 ? " day to go" : " days to go");
      countdown.appendChild(tail);
    }
  })();

  function onKey(event) {
    if (event.key === "Escape") { close(); return; }
    if (event.key !== "Tab" || !card) return;
    var focusables = card.querySelectorAll("a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex='-1'])");
    var list = [].filter.call(focusables, function (el) { return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function open(via) {
    if (isOpen) return;
    isOpen = true;
    openedVia = via || "";
    if (via) track("Popup shown", { via: via });
    hideTab(false);
    lastFocus = document.activeElement;
    box.hidden = false;
    document.body.classList.add("vp-prelaunch-open");
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        box.classList.add("is-open");
        // 桌面把光标直接放进邮箱框；触屏设备别自动聚焦，否则一弹出来就把键盘顶起来
        var target = (!coarse && copy && !copy.hidden && email) ? email : card;
        try { target.focus({ preventScroll: true }); } catch (_) {}
      });
    });
    document.addEventListener("keydown", onKey);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    track("Popup closed", { via: openedVia || "done" });
    box.classList.remove("is-open");
    document.removeEventListener("keydown", onKey);
    document.body.classList.remove("vp-prelaunch-open");
    var state = read();
    if (!state || state.state !== "subscribed") write("dismissed");
    window.setTimeout(function () {
      box.hidden = true;
      showTab();
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (_) {} }
    }, 300);
  }

  // 2026-09-26 用户：订阅后折扣直接到手——结账时自动带上，也能一键复制。
  // /discount/CODE 会让 Shopify 写 discount_code cookie，结账自动套用；redirect 到 /cart.js 省流量。
  // WELCOME10 的资格是「没下过单的顾客」，跟订阅确认无关，所以提交成功就套用；同一会话只请求一次。
  var APPLIED_KEY = "vp-offer-applied";
  function offerCode() {
    var el = box.querySelector("[data-prelaunch-code]");
    return el ? (el.textContent || "").trim() : "";
  }
  function applyCode(override) {
    var code = override || offerCode();
    if (!code || !window.fetch) return;
    try { if (sessionStorage.getItem(APPLIED_KEY) === code) return; } catch (_) {}
    fetch("/discount/" + encodeURIComponent(code) + "?redirect=%2Fcart.js", { credentials: "same-origin" })
      .then(function () { try { sessionStorage.setItem(APPLIED_KEY, code); } catch (_) {} })
      .catch(function () {});
  }
  var copyBtn = box.querySelector("[data-prelaunch-copy]");
  if (copyBtn) copyBtn.addEventListener("click", function () {
    var code = offerCode();
    function ok() {
      copyBtn.textContent = T('js.prelaunch.copied', "Copied");
      copyBtn.classList.add("is-done");
      window.setTimeout(function () { copyBtn.textContent = T('js.prelaunch.copy', "Copy"); copyBtn.classList.remove("is-done"); }, 2200);
    }
    function fallback() {
      try {
        var el = box.querySelector("[data-prelaunch-code]");
        var range = document.createRange(); range.selectNodeContents(el);
        var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range);
        if (document.execCommand("copy")) ok();
      } catch (_) {}
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, fallback);
    else fallback();
  });
  // 圣诞元素：过了 data-xmas-until 那天（访客本地日期）就收掉，防 Liquid 那边的页面缓存
  (function () {
    var m = (box.getAttribute("data-xmas-until") || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return;
    if (new Date() > new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59)) {
      box.classList.remove("vp-prelaunch--xmas");
      [].forEach.call(box.querySelectorAll("[data-xmas]"), function (el) { el.hidden = true; });
      [].forEach.call(box.querySelectorAll("[data-xmas-alt]"), function (el) { el.hidden = false; });  // 10-10：节日眉标收掉后放回普通眉标
    }
  })();

  function showDone() {
    write("subscribed");
    applyCode();
    hideTab(false);
    if (copy) copy.hidden = true;
    if (done) done.hidden = false;
    if (!isOpen) open();
    else { try { card.focus({ preventScroll: true }); } catch (_) {} }
  }

  function showError(message) {
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  }

  [].forEach.call(box.querySelectorAll("[data-prelaunch-close]"), function (el) {
    el.addEventListener("click", function (event) { event.preventDefault(); close(); });
  });
  // 10-10 节日推广：弹窗里的「看礼物」链接照常跳转，同时记为关过弹窗（下一页不再自动弹）
  [].forEach.call(box.querySelectorAll("[data-prelaunch-hlink]"), function (el) {
    el.addEventListener("click", function () {
      var s = read();
      if (!s || s.state !== "subscribed") write("dismissed");
      track("Popup holiday link", { via: openedVia || "auto" });
    });
  });

  // ---- 回流：带着 customer_posted=true 回来的页面 ----
  var posted = false;
  try { posted = new URL(window.location.href).searchParams.get("customer_posted") === "true"; } catch (_) {}
  if (posted) {
    var mine = false;
    try { mine = sessionStorage.getItem(SUBMIT_KEY) === "1"; sessionStorage.removeItem(SUBMIT_KEY); } catch (_) {}
    write("subscribed");
    if (mine) { subscribedOnce(); showDone(); }
    return;
  }

  // ---- 频控 ----
  var saved = read();
  // 订阅过的回访（30 天内）也自动套用 WELCOME10，结账不用再找码
  // 10-15 首单券改成 $5 / €5 / CHF 5 / A$8；之前订阅的人领的是 WELCOME10，回访照旧套 WELCOME10（OLD_CUTOVER = 北京 10-15 13:00）
  var OLD_CUTOVER = Date.UTC(2026, 9, 15, 5, 0);
  if (saved && saved.state === "subscribed") { if (Date.now() - (saved.ts || 0) < 30 * 864e5) applyCode((saved.ts || 0) < OLD_CUTOVER ? "WELCOME10" : ""); return; }
  if (saved && saved.state === "dismissed" && Date.now() - (saved.ts || 0) < snoozeDays * 864e5) { showTab(); return; }
  // 2026-09-27 23:50 用户要求：左侧「10% off」小标签一进站就显示（原来要先关掉弹窗才出现）；弹窗弹出时暂时收起，关掉后回来
  showTab();

  // ---- 提交：只校验 + 打标记，然后让浏览器原生提交（见文件头注释） ----
  if (form) {
    form.addEventListener("submit", function (event) {
      if (error) error.hidden = true;
      if (email && !email.checkValidity()) {
        event.preventDefault();
        showError(T('js.prelaunch.email_invalid', "Please enter a valid email address."));
        email.focus();
        return;
      }
      try { sessionStorage.setItem(SUBMIT_KEY, "1"); } catch (_) {}
      // 2026-09-28：同步发 beacon（见 beacon()）；Shopify 验证码拿到 token 后可能再触发一次 submit，同一页只记一次
      if (!submitSent) { submitSent = true; beacon("Popup submit", openedVia ? { via: openedVia } : null); }
      form.classList.add("is-busy");
      // hCaptcha 可能弹出人机挑战；访客把挑战关掉的话页面不会跳转，8 秒后把按钮放开让他能再点
      window.setTimeout(function () { form.classList.remove("is-busy"); }, 8000);
    });
  }

  // ---- 触发 ----
  // 2026-09-26：原来是页面加载完 delay（2 秒）就弹。实测从 Google 广告进来的手机访客平均只停 11 秒、69% 跳出——
  // 刚看到商品两秒就被一张盖住大半屏的领券卡挡住；Google 也把这种进站即弹的遮挡算进落地页体验扣分。
  // 改成「看得够投入再弹」：往下滚过页面一半，或在页面上停满 30 秒，先到先弹；delay 仍是最早可弹的下限。
  // 同日补充：短页面（如 /collections/bobbleheads，约 3000px）滑一下就过半，刚开始看商品就被弹窗打断，
  // 所以滚动触发还要满足「进页面至少 10 秒」；不满 10 秒就等到第 10 秒再弹（前提是已经滚过一半）。
  // 2026-09-27 23:20 用户要求改快：进站（首页为选完世界后）8 秒就弹，不再等 30 秒 / 滚过半页 + 10 秒
  var ENGAGE_MS = 8000, ENGAGE_DEPTH = 0.5, MIN_STAY_MS = 8000;
  // 2026-09-28 popup_consent（用户 16:35 批准）：领券弹窗不跟 Shopify 的 Cookie 横幅同时弹（欧洲手机上两个一起盖满屏）。
  // 只管自动弹出（fire）这条路；点小标签手动打开不受影响。横幅只在欧盟 27 国 + GB / NO / IS / LI 出现，美国等地区照旧 8 秒弹。
  //  · arm() 起就预先加载 Shopify 的 consent-tracking-api（到 8 秒时结果早已就绪），并监听 visitorConsentCollected 记下表态时间。
  //  · fire() 先问 Shopify.customerPrivacy.shouldShowBanner()（没表态且在需同意地区才为 true）：
  //    true → 这次不弹，等访客在横幅上表态（visitorConsentCollected）后，页面可见状态下再过 8 秒弹；一直不表态就不弹；
  //    false 但刚表态不满 8 秒 → 补足 8 秒再弹；否则照原逻辑马上弹。
  //  · 接口 3 秒没回来 / 出错 / 页面上没有 Shopify.loadFeatures → 照原逻辑直接弹（fail-open）。
  //  · 延后的那一次弹出前，访客如果已经自己点小标签打开并关掉过（或订阅了），就不再自动弹。
  var CONSENT_WAIT_MS = 3000, CONSENT_GAP_MS = 1500;  // 10-12：表态后 1.5 秒弹（原来 8 秒）
  var pageAt = Date.now(), consentAt = 0, privacyState = "", privacyCbs = [];
  function privacyApi() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return p && typeof p.shouldShowBanner === "function" ? p : null;
  }
  function loadPrivacy(cb) {
    if (privacyState === "ok" || privacyState === "fail") { cb(); return; }
    privacyCbs.push(cb);
    if (privacyState) return;
    privacyState = "loading";
    function settle(state) {
      if (privacyState !== "loading") return;
      privacyState = state;
      var list = privacyCbs; privacyCbs = [];
      for (var i = 0; i < list.length; i++) { try { list[i](); } catch (_) {} }
    }
    if (privacyApi()) { settle("ok"); return; }
    try {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) { settle(!err && privacyApi() ? "ok" : "fail"); });
    } catch (_) { settle("fail"); }
  }
  function bannerUp() {
    var p = privacyState === "ok" && privacyApi();
    try { return !!(p && p.shouldShowBanner()); } catch (_) { return false; }
  }
  function touched() { var s = read(); return !!(s && (s.ts || 0) >= pageAt); }
  var armed = false, armedAt = 0;
  function arm() {
    if (armed) return;
    armed = true;
    if (AUTO_OFF || adVisit) return;  // 10-14 广告访客不自动弹（见上面 AD_RE）；10-12 用户：所有地区都在加载完 8 秒后弹（不再按「需同意地区」关掉）
    armedAt = Date.now();
    document.addEventListener("visitorConsentCollected", function () { consentAt = Date.now(); });
    loadPrivacy(function () {});  // 预先加载 consent-tracking-api，8 秒时好判断 Cookie 横幅还在不在
    var fired = false, timer = 0, stayTimer = 0;
    function show(later) {
      if (later && touched()) return;
      if (!document.hidden) { open("auto"); return; }
      document.addEventListener("visibilitychange", function once() { document.removeEventListener("visibilitychange", once); if (later && touched()) return; open("auto"); });
    }
    // 页面可见的时间累计满 ms 再弹（切到后台就暂停计时）
    function showAfter(ms) {
      var left = ms, t = 0, since = 0;
      function tick() {
        if (document.hidden) { if (t) { window.clearTimeout(t); t = 0; left -= Date.now() - since; } return; }
        if (t) return;
        since = Date.now();
        t = window.setTimeout(function () { document.removeEventListener("visibilitychange", tick); show(true); }, Math.max(0, left));
      }
      document.addEventListener("visibilitychange", tick);
      tick();
    }
    function fire() {
      if (fired) return;
      fired = true;
      window.removeEventListener("scroll", onScroll);
      window.clearTimeout(timer);
      var decided = false;
      var guard = window.setTimeout(function () { if (!decided) { decided = true; show(false); } }, CONSENT_WAIT_MS);
      loadPrivacy(function () {
        if (decided) return;
        decided = true;
        window.clearTimeout(guard);
        // 10-12 用户：「所有地区都会显示，在网站加载完毕后八秒钟弹出」→ Cookie 横幅还在也照样弹；vp-gift.js 会把弹窗抬到横幅上面，两层不重叠、横幅照常能点
        var gap = consentAt ? CONSENT_GAP_MS - (Date.now() - consentAt) : 0;
        if (gap > 0) showAfter(gap); else show(false);
      });
    }
    function onScroll() {
      var doc = document.documentElement;
      if ((window.scrollY + window.innerHeight) / Math.max(1, doc.scrollHeight) < ENGAGE_DEPTH) return;
      var wait = MIN_STAY_MS - (Date.now() - armedAt);
      if (wait <= 0) { fire(); return; }
      if (!stayTimer) stayTimer = window.setTimeout(fire, wait);
    }
    timer = window.setTimeout(fire, Math.max(delay, ENGAGE_MS));
    window.setTimeout(function () { if (!fired) window.addEventListener("scroll", onScroll, { passive: true }); }, delay);
  }
  if (root.getAttribute("data-entry") === "gateway") {
    window.addEventListener("vp:entryready", function once() { window.removeEventListener("vp:entryready", once); arm(); });
  } else if (document.readyState === "complete") {
    arm();
  } else {
    window.addEventListener("load", arm);
  }
})();
